import script from "./TheGlobalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheGlobalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TheGlobalHeader.vue?vue&type=style&index=0&id=8ccf8cd4&lang=css"

const __exports__ = script;

export default __exports__